import PageContainerMobile from 'components/PageContainer/layout/PageContainer.mobile'
import {
  Button,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  ListItemText,
  MenuItem,
  Select
} from '@material-ui/core'
import { GRAY_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { CloseIcon } from 'asterX-UI/Icons'
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CheckIcon from '@material-ui/icons/Check'
import useSeoApis from 'hooks/useSeoApis'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { useAuthStore } from 'context/AuthStore'

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  row: {
    marginTop: 32,
    display: 'flex',
    flexDirection: 'row',
    gap: 16
  },
  cross: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  round: {
    width: 70,
    height: 70,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '8px solid' + SUCCESS_COLORS['50'],
    backgroundColor: SUCCESS_COLORS['100'],
    margin: 'auto',
    marginBottom: 20
  },
  successText: {
    fontSize: 14,
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center'
  }
}))

const RedirectClient = ({ onClose }) => {
  const { authStore } = useAuthStore()
  const { redirectClient, seoLoading, hasActiveTicket } = useSeoApis()
  const {
    store: { sale },
    funcs: { updateStatusTrack, carfinUpdateStatusTrack }
  } = useSelectionStore()

  const redirectOptions = [
    { value: 1, label: 'Фин сервис (консультация)' },
    { value: 3, label: 'Trade-In / Талон Т' }
  ]
  const classes = useStyles()
  const [isSuccessful, setIsSuccessful] = useState(false)
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState([])
  const [activeTicket, setActiveTicket] = useState(null)
  const ticketId = authStore?.seoDepartments?.filter(
    item => item.TicketPrefix === 'T'
  )
  useEffect(() => {
    hasActiveTicket({
      onSuccess: data => setActiveTicket(data)
    })
  }, [])
  const onSave = async () => {
    setLoading(true)
    if (options.includes(1)) {
      await updateStatusTrack(20)
      await carfinUpdateStatusTrack(10)
    }
    if (options.includes(3)) {
      return await redirectClient({
        target: `d${ticketId[0]?.Id}`,
        saleId: sale?.id,
        onSuccess: res => {
          setLoading(false)
          if (!!res) {
            setIsSuccessful(true)
          }
        }
      })
    }

    setLoading(false)
    setIsSuccessful(true)
  }
  return !isSuccessful ? (
    <PageContainerMobile
      customHeader={
        <div className={classes.header}>
          <div className={classes.heading}>Перенаправить</div>
          <IconButton
            style={{
              color: GRAY_COLORS[400],
              fontSize: 24
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <LoaderBackdrop loading={loading || seoLoading} />
      <FormControl fullWidth>
        <InputLabel id="redirectOptions-label">Отдел</InputLabel>
        <Select
          multiple
          labelId={'redirectOptions-label'}
          select
          fullWidth
          value={options}
          onChange={e => setOptions(e.target.value)}
          renderValue={selected => {
            if (selected.length === 0) {
              return <em>Отдел</em>
            }
            const labels = selected.map(
              v => redirectOptions.find(o => o.value === v).label
            )
            return labels.join(', ')
          }}
          name={'redirectOptions'}
        >
          {redirectOptions
            .filter(v => (!!activeTicket ? true : v.value === 1))
            .map(v => (
              <MenuItem key={v.value} value={v.value}>
                <Checkbox
                  color={'primary'}
                  checked={options.includes(v.value)}
                />
                <ListItemText primary={v.label} />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <div className={classes.row}>
        <Button fullWidth onClick={onClose} variant={'contained'}>
          Отмена
        </Button>
        <Button
          color={'primary'}
          variant={'contained'}
          fullWidth
          onClick={onSave}
        >
          Перенаправить
        </Button>
      </div>
    </PageContainerMobile>
  ) : (
    <PageContainerMobile
      customHeader={
        <div className={classes.cross}>
          <IconButton
            style={{
              color: GRAY_COLORS[400],
              fontSize: 24
            }}
            onClick={onClose}
            size={'medium'}
          >
            <CloseIcon />
          </IconButton>
        </div>
      }
    >
      <div className={classes.round}>
        <CheckIcon style={{ fontSize: 24, color: SUCCESS_COLORS['700'] }} />
      </div>
      <div className={classes.successText}>Клиент успешно перенаправлен</div>
    </PageContainerMobile>
  )
}

export default RedirectClient
